
(() => {
  // ===== Config =====
  const MAX_TRIES = 80;       // 80 * 50ms = ~4s
  const TRY_EVERY_MS = 50;
  const EXTRA_OFFSET = 8;

  // Lock para no repetir scroll infinitamente
  let lastScrolledHash = null;
  let scrollDoneForHash = false;
  let mo = null;

  function cssEscapeSafe(id) {
    if (window.CSS && CSS.escape) return CSS.escape(id);
    return id.replace(/([ #;?%&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
  }

  function getStickyHeaderOffset() {
    const candidates = [
      document.querySelector('header.header'),
      document.querySelector('.section-header'),
      document.querySelector('#shopify-section-header'),
      document.querySelector('[data-sticky-header]'),
      document.querySelector('.header-wrapper'),
    ].filter(Boolean);

    let h = 0;
    for (const el of candidates) {
      const styles = window.getComputedStyle(el);
      if (styles.display === 'none' || styles.visibility === 'hidden') continue;
      const rect = el.getBoundingClientRect();
      if (styles.position === 'fixed' || styles.position === 'sticky') {
        h = Math.max(h, rect.height || el.offsetHeight || 0);
      }
    }
    return h;
  }

  function findTargetByHash(hash) {
    if (!hash) return null;
    const id = hash.startsWith('#') ? hash.slice(1) : hash;
    if (!id) return null;

    let el = document.getElementById(id);
    if (el) return el;

    el = document.querySelector(`[name="${cssEscapeSafe(id)}"]`);
    if (el) return el;

    el = document.querySelector(`#${cssEscapeSafe(id)}`);
    return el || null;
  }

  function scrollToElement(el, { behavior = 'smooth' } = {}) {
    const header = getStickyHeaderOffset();
    const y = window.scrollY + el.getBoundingClientRect().top - header - EXTRA_OFFSET;
    window.scrollTo({ top: Math.max(y, 0), behavior });
  }

  function stopObserver() {
    if (mo) {
      mo.disconnect();
      mo = null;
    }
  }

  function scrollToHashReliable(hash, { behavior = 'smooth', updateUrl = true } = {}) {
    const targetHash = hash || window.location.hash;
    if (!targetHash || targetHash === '#') return;

    // Si ya lo hicimos para este hash, no repetir
    if (scrollDoneForHash && lastScrolledHash === targetHash) return;

    // Nueva navegación de hash: resetea lock
    if (lastScrolledHash !== targetHash) {
      lastScrolledHash = targetHash;
      scrollDoneForHash = false;
    }

    let tries = 0;

    const attempt = () => {
      // Si ya quedó, no reintentar
      if (scrollDoneForHash && lastScrolledHash === targetHash) return;

      const el = findTargetByHash(targetHash);
      if (el) {
        // Scroll UNA vez (y un micro-ajuste opcional 1 sola vez)
        scrollToElement(el, { behavior });

        // micro-fix único por si fonts/img mueven 1 poquito después
        setTimeout(() => {
          if (scrollDoneForHash && lastScrolledHash === targetHash) {
            scrollToElement(el, { behavior: 'auto' });
          }
        }, 180);

        scrollDoneForHash = true;
        stopObserver();

        if (updateUrl) {
          if (history && history.replaceState) history.replaceState(null, '', targetHash);
          else window.location.hash = targetHash;
        }
        return;
      }

      tries++;
      if (tries >= MAX_TRIES) {
        // Si no apareció, ya no sigas
        stopObserver();
        return;
      }

      setTimeout(attempt, TRY_EVERY_MS);
    };

    attempt();
  }

  // ===== Interceptar clicks =====
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a) return;

    const href = a.getAttribute('href');
    if (!href) return;

    let url;
    try { url = new URL(href, window.location.href); } catch { return; }

    const isSamePage =
      url.origin === window.location.origin &&
      url.pathname.replace(/\/+$/, '') === window.location.pathname.replace(/\/+$/, '');

    if (!isSamePage) return;

    const hash = url.hash;
    if (!hash || hash === '#') return;

    e.preventDefault();

    // Resetea lock para este nuevo hash
    lastScrolledHash = hash;
    scrollDoneForHash = false;

    if (history && history.pushState) history.pushState(null, '', hash);
    else window.location.hash = hash;

    // Activa observer SOLO mientras encuentra el target
    if (!mo) {
      mo = new MutationObserver(() => {
        if (!scrollDoneForHash && window.location.hash) {
          scrollToHashReliable(window.location.hash, { behavior: 'auto', updateUrl: false });
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }

    scrollToHashReliable(hash, { behavior: 'smooth', updateUrl: true });
  }, true);

  // ===== Carga inicial =====
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.location.hash) return;

    lastScrolledHash = window.location.hash;
    scrollDoneForHash = false;

    // observer SOLO hasta lograrlo
    mo = new MutationObserver(() => {
      if (!scrollDoneForHash && window.location.hash) {
        scrollToHashReliable(window.location.hash, { behavior: 'auto', updateUrl: false });
      } else {
        stopObserver();
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    scrollToHashReliable(window.location.hash, { behavior: 'auto', updateUrl: false });
  });

  window.addEventListener('load', () => {
    if (window.location.hash && !scrollDoneForHash) {
      scrollToHashReliable(window.location.hash, { behavior: 'auto', updateUrl: false });
    }
  });

  window.addEventListener('hashchange', () => {
    if (!window.location.hash) return;

    lastScrolledHash = window.location.hash;
    scrollDoneForHash = false;

    if (!mo) {
      mo = new MutationObserver(() => {
        if (!scrollDoneForHash && window.location.hash) {
          scrollToHashReliable(window.location.hash, { behavior: 'auto', updateUrl: false });
        } else {
          stopObserver();
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    }

    scrollToHashReliable(window.location.hash, { behavior: 'smooth', updateUrl: false });
  });
})();
